// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { InvoiceHolderFragment } from '../../fragments/generated/invoice-holder.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetOpenSubAccountHoldersQueryVariables = Types.Exact<{
  reservationId: Types.Scalars['Int']['input'];
}>;


export type GetOpenSubAccountHoldersQueryResult = { __typename?: 'Query', getOpenSubAccountHolders: Array<{ __typename?: 'InvoiceHolderDTO', id: number, fiscalCode: string | null, vatNumber: string | null, fullName: string, name: string | null, surname: string | null, corpName: string | null, address: string | null, city: string | null, cityId: number | null, mail: string | null, mobile: string | null, invoiceHolderType: Types.InvoiceHolderTypeDto, invoiceDocumentType: Types.InvoiceDocumentTypeDto | null }> };

export const GetOpenSubAccountHoldersGql = gql`
    query GetOpenSubAccountHolders($reservationId: Int!) {
  getOpenSubAccountHolders(reservationId: $reservationId) {
    ...InvoiceHolder
  }
}
    ${InvoiceHolderFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOpenSubAccountHoldersInjectable extends Apollo.Query<GetOpenSubAccountHoldersQueryResult, GetOpenSubAccountHoldersQueryVariables> {
    override document = GetOpenSubAccountHoldersGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */